var map = {
	"./before-dawn.svg": 6759,
	"./bus.svg": 8753,
	"./chef.svg": 3056,
	"./fun.svg": 3861,
	"./health.svg": 3019,
	"./house.svg": 3634,
	"./interview.svg": 6099,
	"./love.svg": 976,
	"./lunch-time.svg": 5293,
	"./purchase.svg": 676,
	"./reading-listening.svg": 7646,
	"./school.svg": 478,
	"./spor.svg": 4925,
	"./trip.svg": 2975,
	"./working.svg": 7544
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1323;